import Cookies, { CookieAttributes } from 'js-cookie';

const set = (key: string, data: string, options?: CookieAttributes) => {
  Cookies.set(key, data, options);
};

const get = (key: string) => {
  return Cookies.getJSON(key);
};

const remove = (key: string) => {
  return Cookies.remove(key);
};

export default {
  set,
  get,
  remove
};
